import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class InviteModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invitelink: null,
            path:null,
            copyText: null,
        };
    }

    componentDidMount() {
        this.setState({ invitelink: this.props.link,path: window.location.hostname, copyText: 'Copy Link' });
    }

    copyToClipboard = (e) => {
        navigator.clipboard.writeText(this.state.invitelink);
        this.setState({ copyText: 'Copied!' });
      };

    
    render() {
        return (
            
            <div className="model-container model-center model-backdrop-show inviteModal">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/clip.png" className="linkImg mr-3"/>
                        <h2 className="model-title" id="model-title">Get Link</h2>
                    </div>
                    
                    <div className="model-content">
                        <div className="inviteLink flex">
                        <input type="text" disabled className="form-control" id="link" placeholder="link" value={this.state.invitelink} />
        <button type="button" className="btn btn-primary mb-2" onClick={this.copyToClipboard}>{this.state.copyText}</button>
                        </div>
                        
                    </div>
                    <div className="model-actions">
                        {/* <button
                            type="button"
                            className="btn btn-danger"
                            onClick={this.props.hideInvite}
                        >
                            Send
                        </button> */}
                        <button
                            type="button"
                            onClick={this.props.hideInvite}
                            className="btn btn-manage"
                        >
                            Done
                        </button>
                    </div>
                </div>
            </div>
                   
        );
    }
}
InviteModel.contextType = AppContext;
export default InviteModel;



// WEBPACK FOOTER //
// ./src/components/admin/employers/InviteModel.js